import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideIonicAngular, IonicRouteStrategy, AlertController } from '@ionic/angular/standalone';
import { routes } from './app.routes';
import {
  createSimpleAuthInterceptor,
  TOKEN_STORAGE,
  CONSENT_HTTP_SERVICE,
  AUTH_STORAGE_SERVICE,
  USER_ID_EXTRACTOR,
  PWA_INSTALL_SERVICE,
  ALERT_SERVICE,
  BasePwaInstallService,
  BaseLegalContentService,
  LEGAL_CONTENT_CONFIG,
  BaseConsentHttpService,
  CONSENT_HTTP_CONFIG,
  BaseAppNotificationService,
  APP_NOTIFICATION_CONFIG,
  BaseOneSignalService,
  ONESIGNAL_CONFIG,
  getUserIdFromToken
} from '@appchezandre/angular-ui';
import { StorageService } from './services/storage.service';
import { tokenRefreshInterceptor } from './interceptors/token-refresh.interceptor';
import { environment } from '../environments/environment';
// import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([
      createSimpleAuthInterceptor(), // Ajoute le token aux requêtes
      tokenRefreshInterceptor // Refresh automatique si 401
    ])),
    provideIonicAngular({
      backButtonText: 'Retour'
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },

    // // Angular Service Worker (NGSW) - Scope racine /
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),

    // Auth & Storage
    { provide: TOKEN_STORAGE, useClass: StorageService },
    { provide: AUTH_STORAGE_SERVICE, useClass: StorageService },

    // Cookie Consent
    {
      provide: CONSENT_HTTP_CONFIG,
      useValue: {
        apiUrl: `${environment.apiUrl}/consent`,
        applicationCode: 'labase'
      }
    },
    { provide: CONSENT_HTTP_SERVICE, useClass: BaseConsentHttpService },
    { provide: USER_ID_EXTRACTOR, useValue: { getUserIdFromToken } },

    // PWA Install
    { provide: PWA_INSTALL_SERVICE, useClass: BasePwaInstallService },

    // Alert Service (for modals)
    { provide: ALERT_SERVICE, useClass: AlertController },

    // Legal Content
    {
      provide: LEGAL_CONTENT_CONFIG,
      useValue: {
        apiUrl: `${environment.apiUrl}/legal-content`,
        applicationCode: 'labase'
      }
    },
    BaseLegalContentService,

    // App Notification Service
    {
      provide: APP_NOTIFICATION_CONFIG,
      useValue: {
        apiUrl: `${environment.apiUrl}/app-notifications`,
        applicationCode: 'labase'
      }
    },
    BaseAppNotificationService,

    // OneSignal Service
    {
      provide: ONESIGNAL_CONFIG,
      useValue: {
        appId: environment.oneSignal.appId,
        allowLocalhostAsSecureOrigin: true,
        serviceWorkerPath: 'OneSignalSDKWorker.js',
        serviceWorkerParam: { scope: '/' }
      }
    },
    BaseOneSignalService,
  ],
};